import * as React from "react";

import ZoomFullScreen from "@/components/zoomFullScreen";
import ImageIcon from "@mui/icons-material/Image";
import IconButton from "@mui/material/IconButton";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import _ from "lodash";
import connectConfig from "../config/connectConfig";
export default function ImageZoom(props) {
  const { attachments = [], icon = false } = props;
  //turn on ZoomFullScreen and store uri soure into state
  const [isZoomFullScreenOpen, setZoomFullScreenOpen] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const handleClickOpen = (index) => {
    setSelectedIndex(index);
    setZoomFullScreenOpen(true);
  };
  // turn off ZoomFullScreen
  const handleClose = () => {
    setZoomFullScreenOpen(false);
  };
  const imageListWidth = Object.keys(attachments).length * 160;

  return (
    <>
      <ImageList
        cols={Object.keys(attachments).length}
        sx={{ width: imageListWidth, maxWidth: "100%", pl: 1, pr: 1 }}
      >
        {_.map(attachments, (attachment, index) => {
          if (icon) {
            return (
              <IconButton
                key={index}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleClickOpen(index);
                }}
              >
                <ImageIcon></ImageIcon>
              </IconButton>
            );
          } else {
            return (
              <ImageListItem key={index}>
                <div
                  onClick={() => handleClickOpen(index)}
                  className="zoom-in"
                  role="img"
                  style={{
                    borderRadius: "14px",
                    width: "150px",
                    height: "150px",
                    border: "1px solid #f4f6f8",
                    backgroundImage: `url("${connectConfig.s3}/${attachment}")`,
                    backgroundPosition: "50%",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                  }}
                />
              </ImageListItem>
            );
          }
        })}
      </ImageList>
      <ZoomFullScreen
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        attachments={attachments}
        open={isZoomFullScreenOpen}
        handleClose={handleClose}
      />
    </>
  );
}
